export const GROUPS_PREFIX = '@USER_GROUPS';
